import { AUTHORIZATION } from '../../constants/authorization';
import useAuthorisedEntities from './useAuthorisedEntities';
import useSelectedLp from './useSelectedLp';

export function useLpAccessRights() {
  const authorizedEntities = useAuthorisedEntities();
  const lpSelected = useSelectedLp();

  const rights = authorizedEntities?.[lpSelected?.lpId];

  return {
    hasAdminRights: rights?.includes(AUTHORIZATION.ADMIN),
    hasAccessRights: rights?.includes(AUTHORIZATION.ACCESS),
  };
}

export default useLpAccessRights;
